import axios from '@/axios'

// Material Text Book

export async function upload (file) {
  const { data } = await axios.post(
    import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/upload',
    { filename: file.name }
  )
  await putToR2(data.data.upload_url, file, data.data.headers)
  return data.data
}

export async function uploadCover (file) {
  const { data } = await axios.post(
    import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/upload-cover',
    { filename: file.name }
  )
  await putToR2(data.data.upload_url, file, data.data.headers)
  return data.data
}

async function putToR2 (url, file, headers = {}) {
  const res = await fetch(url, { method: 'PUT', body: file, headers })
  if (!res.ok) throw new Error(`Falha no upload para o R2 (${res.status})`)
}

export function newTextbook (data) {
  return axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks', data)
}

export async function listTextBooks (page, parameters) {
  let url = import.meta.env.VITE_API_URL + '/v2/intranet/textbooks?page=' + page

  if (parameters) {
    url = url + parameters
  }

  const response = await axios.get(url)
  return response.data
}
export async function getTextBook (id) {
  const response = await axios.get(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/' + id)
  return response.data.data
}

// export async function upload (formData) {
//   const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
//   return response.data.data
// }

// export async function uploadCover (formData) {
//   const response = await axios.post(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/upload-cover', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
//   return response.data.data
// }

export function updateTextBook (id, data) {
  return axios.put(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/' + id, data)
}

export function deleteTextBook (id) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks/' + id)
}
export function bulkDeleteTextBook (data) {
  return axios.delete(import.meta.env.VITE_API_URL + '/v2/intranet/textbooks', { data })
}

export default {
  newTextbook,
  listTextBooks,
  getTextBook,
  upload,
  uploadCover,
  updateTextBook,
  deleteTextBook,
  bulkDeleteTextBook
}
